// FOOTIE + football-onboarding modals.
import { useState } from "react";
import { X } from "lucide-react";
import { FootieBall } from "./FootieIcon";
import { FORMATION_LIST, DEFAULT_FORMATION } from "../../utils/football";

// A) First-time FOOTIE introduction — ball bounces in from the bottom.
export function FootieIntroModal({ onDismiss }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/70 p-4 backdrop-blur-sm sm:items-center" data-testid="footie-intro-modal">
      <div className="footie-bounce-in w-full max-w-sm rounded-2xl border border-amber-500/30 bg-slate-800 p-6 text-center">
        <div className="footie-ball-bounce mx-auto mb-3 w-fit">
          <FootieBall size={72} />
        </div>
        <h2 className="text-xl font-extrabold text-white">👋 Meet FOOTIE — your Smart Squad Builder</h2>
        <p className="mt-2 text-sm text-slate-300">FOOTIE picks 11 players, captain, and VC. You review before locking.</p>
        <p className="mt-1 text-sm text-slate-400">Use it when you're short on time. Squad in 5 seconds.</p>
        <button
          onClick={onDismiss}
          className="mt-5 w-full rounded-xl wc-bg-gold py-3 text-sm font-extrabold text-slate-900"
          data-testid="footie-intro-dismiss"
        >
          Got it
        </button>
      </div>
    </div>
  );
}

// D) FOOTIE build modal — formation selector + reminder.
export function FootieBuildModal({ open, onClose, onBuild, building }) {
  const [formation, setFormation] = useState(DEFAULT_FORMATION);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm" data-testid="footie-build-modal">
      <div className="w-full max-w-sm rounded-2xl border border-amber-500/30 bg-slate-800 p-5">
        <div className="mb-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <FootieBall size={26} />
            <h2 className="text-lg font-extrabold text-white">Build with FOOTIE</h2>
          </div>
          <button onClick={onClose} className="text-slate-400" data-testid="footie-build-close"><X size={20} /></button>
        </div>

        <p className="mb-2 text-sm font-bold text-slate-300">Pick your formation</p>
        <div className="mb-4 flex flex-wrap gap-2" data-testid="footie-formation-row">
          {FORMATION_LIST.map((f) => (
            <button
              key={f}
              onClick={() => setFormation(f)}
              className={`rounded-full border px-3.5 py-1.5 text-sm font-extrabold transition-all ${formation === f ? "wc-bg-gold border-amber-400 text-slate-900" : "border-slate-600 bg-slate-900 text-slate-300"}`}
              data-testid={`footie-formation-${f}`}
            >
              {f}
            </button>
          ))}
        </div>

        <p className="mb-4 text-sm text-slate-400">FOOTIE picks 11 players, captain, and VC from teams playing today. You review before locking.</p>

        <button
          onClick={() => onBuild(formation)}
          disabled={building}
          className="w-full rounded-xl wc-bg-gold py-3 text-sm font-extrabold text-slate-900 disabled:opacity-50"
          data-testid="footie-build-continue"
        >
          {building ? "FOOTIE is building…" : `Continue with ${formation}`}
        </button>
      </div>
    </div>
  );
}

// F-A) Football mode entry one-time modal — reframes the daily commitment.
export function FootballOnboardingModal({ onDismiss }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm" data-testid="football-onboarding-modal">
      <div className="w-full max-w-sm rounded-2xl border border-amber-500/30 bg-slate-800 p-6">
        <h2 className="text-xl font-extrabold text-white">Football works differently from cricket</h2>
        <p className="mt-3 text-sm text-slate-300">
          There's no season team in football. Each match day is its own fresh start — pick 11, lock before kickoff, score points. Skip days you don't have time. Use FOOTIE if you're short on time.
        </p>
        <button
          onClick={onDismiss}
          className="mt-5 w-full rounded-xl wc-bg-gold py-3 text-sm font-extrabold text-slate-900"
          data-testid="football-onboarding-dismiss"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
